import { useQuery } from '@tanstack/react-query';
import { getMasterMedicines } from '../requests';

export const useMasterMedicines = (page: number, limit: number) => {
  const { data, isLoading } = useQuery({
    queryFn: () => getMasterMedicines(page, limit),
    queryKey: ['master-medicines', page, limit]
  });

  return {
    masterMedicines: data?.data.data || [],
    isLoading,
    total: data?.data.pagination?.total
  };
};
